import { Navigate, Route, Routes } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import AboutPage from '../pages/About/AboutPage';
import BlogDetailPage from '../pages/Blog/BlogDetailPage';
import BlogPage from '../pages/Blog/BlogPage';
import CertificationsPage from '../pages/Certifications/CertificationsPage';
import ContactPage from '../pages/Contact/ContactPage';
import ExportPage from '../pages/Export/ExportPage';
import FAQPage from '../pages/FAQ/FAQPage';
import FranchisePage from '../pages/Franchise/FranchisePage';
import HomePage from '../pages/Home/HomePage';
import CategoryDetailPage from '../pages/Products/CategoryDetailPage';
import ProductsPage from '../pages/Products/ProductsPage';
import TeamPage from '../pages/Team/TeamPage';

function AppRoutes() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/products/:category" element={<CategoryDetailPage />} />
        <Route path="/franchise" element={<FranchisePage />} />
        <Route path="/export" element={<ExportPage />} />
        <Route path="/certifications" element={<CertificationsPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogDetailPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default AppRoutes;
